import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { markNotificationCenterAsRead } from '@src/redux/actions/notificationCenter';
import { isNotificationCenterVisible, getNotificationCenterNewCount } from '@src/redux/selectors/notificationCenter';
import { RootState } from '@src/redux/interfaces/redux.interface';
import { trackEvent } from '@src/metrics';
import './styles.scss';

export const RefetchButton = ({
  isNotificationCenterVisible,
  newNotificationsCount,
  fetchNewNotifications,
  markNotificationCenterAsRead,
}) => {
  const [hasUpdatedNotificationCenter, setHasUpdatedNotificationCenter] = useState(true);

  useEffect(() => {
    if (isNotificationCenterVisible) {
      markNotificationCenterAsRead();
      setHasUpdatedNotificationCenter(true);
    }
  }, [isNotificationCenterVisible]);

  useEffect(() => {
    if (!isNotificationCenterVisible && newNotificationsCount > 0) {
      fetchNewNotifications();
      setHasUpdatedNotificationCenter(true);
    }

    if (isNotificationCenterVisible && newNotificationsCount > 0) {
      setHasUpdatedNotificationCenter(false);
    }
  }, [newNotificationsCount]);

  return (
    <div
      className={classnames('notification-center-refetch-button', {
        'notification-center-refetch-button--hidden': hasUpdatedNotificationCenter,
      })}
    >
      <div
        className="notification-center-refetch-button__text"
        onClick={() => {
          fetchNewNotifications();
          markNotificationCenterAsRead();
          setHasUpdatedNotificationCenter(true);

          trackEvent({
            context: MetricContext.NOTIFICATION_CENTER,
            interaction: MetricAction.LOAD_NEW_NOTIFICATIONS,
          });
        }}
      >
        New notifications
      </div>
    </div>
  );
};

RefetchButton.propTypes = {
  fetchNewNotifications: PropTypes.func.isRequired,
  isNotificationCenterVisible: PropTypes.bool.isRequired,
  markNotificationCenterAsRead: PropTypes.func.isRequired,
  newNotificationsCount: PropTypes.number,
};

export default connect(
  (state: RootState) => ({
    isNotificationCenterVisible: isNotificationCenterVisible(state),
    newNotificationsCount: getNotificationCenterNewCount(state),
  }),
  {
    markNotificationCenterAsRead,
  },
)(RefetchButton);
